/**
 * « Passer » vaut pour la session, pas pour l'éternité.
 *
 * Qui veut entrer doit pouvoir entrer : sans cette mémoire, la garde de route ramènerait la
 * personne sur l'accueil à chaque navigation, puisque son nom est toujours vide. Elle n'est
 * pas persistée — au prochain onglet la proposition revient, et c'est voulu : un compte sans
 * nom s'affiche par son adresse partout dans le produit.
 */
let passe = false;

export function marquerAccueilPasse() {
  passe = true;
}

export function accueilPasse() {
  return passe;
}
